import { createContext, useContext } from "react";
import type { useFormContext } from "react-hook-form";
import { z } from "zod";

export interface GridRowData extends Record<string, any> {
  id: string;
}

export type GridData = GridRowData[];

export const GridFormSchema = z.object({
  rowIds: z.array(z.string()),
  rowIdsSelectAll: z.boolean().optional(),
});

export type GridFormValues = z.infer<typeof GridFormSchema>;

export interface GridFormContextValue {
  data: GridData;
  formContext: ReturnType<typeof useFormContext<GridFormValues>>;
  selectedRowIds: string[];
  hasSelection: boolean;
  clearSelection: () => void;
  getLastClickedRowId: () => string | null;
  setLastClickedRowId: (id: string | null) => void;
}

export const GridFormContext = createContext<GridFormContextValue | null>(null);

export const useGridForm = () => {
  const context = useContext(GridFormContext);

  if (!context) {
    throw new Error("useGridForm must be used within a GridFormProvider");
  }

  return context;
};
